import {NfMessage} from "./NfMessage";

/**
 * Wiadomość pochodząca z konkretnego komponentu
 */
export class NfComponentMessage extends NfMessage {

    public widgetId:number = -1;
    public serviceInstanceId:number = -1;
    public componentId:number = -1;
    public uuid:number = -1;
    public browserTabId:string = '';
}